import { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
function CardServizi() {
    const history = useHistory();
    const [ser, setSer] = useState([])

    const getSer = () => {
        fetch(`${document.apiURL}/home/services`, {
            method: 'GET',

            headers: {
                'x-access-token': localStorage.getItem('Token'),
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
            .then(data => {

                setSer(data.services.map(s => { return { photo: s.icon, text: s.title, sub: s.descr } }))

            })


    }

    useEffect(() => {
        getSer()
    }, []);

    return (<>
        {ser.map((e) =>
            <div style={{ cursor: 'pointer' }} onClick={() => history.push(`/prestazione/${e.text.toLowerCase().replace(/[^a-zA-Z0-9-_]/g, '-')}`)} className="card" >
                <img alt={e.text} src={e.photo} className="img-card" />
                <div className="text-card">
                    <div className="min-height">
                        <h4>{e.text}</h4>
                    </div>
                    <p className="sub">{e.sub}</p>

                </div>
            </div>
        )}


        {/*ser.map((e) =>
            <div className="card" key={e.id}>
                <img src={e.icon} className="img-card" />
                <div className="text-card">
                    <div className="min-height">
                        <h4>{e.title}</h4>
                    </div>
                    <p className="sub">{e.descr}</p>
                </div>
            </div>
        )*/}</>
    );
}

export default CardServizi;